/*
* 讯飞文字转语音
* 配置在ProjectConfig
*/
class broadcast {
  constructor() {
    this.ttsWS = null
    this.init()
  }
  
  init(){
    this.audioPlayer = new AudioPlayer("static/tts-demo/dist");
  }
  
  play(option){
    this.stop();
    this.connectWebSocket(option);
  }
  
  stop(){
    this.audioPlayer.stop();
    this.audioPlayer.reset();
    console.log(this.audioPlayer)
  }
  
  getWebSocketUrl() {
    var url = "wss://tts-api.xfyun.cn/v2/tts";
    var host = location.host;
    var date = new Date().toGMTString();
    var algorithm = "hmac-sha256";
    var headers = "host date request-line";
    var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/tts HTTP/1.1`;
    var signatureSha = window.CryptoJS.HmacSHA256(signatureOrigin, window.broadcastConfig.API_SECRET);
    var signature = window.CryptoJS.enc.Base64.stringify(signatureSha);
    var authorizationOrigin = `api_key="${window.broadcastConfig.API_KEY}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
    var authorization = btoa(authorizationOrigin);
    url = `${url}?authorization=${authorization}&date=${date}&host=${host}`;
    return url;
  }
  
  encodeText(text, type) {
    if (type === "unicode") {
      let buf = new ArrayBuffer(text.length * 4);
      let bufView = new Uint16Array(buf);
      for (let i = 0, strlen = text.length; i < strlen; i++) {
        bufView[i] = text.charCodeAt(i);
      }
      let binary = "";
      let bytes = new Uint8Array(buf);
      let len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    } else {
      return window.Base64.encode(text);
    }
  }
  
  // 开始合成语音
  connectWebSocket(option = {}) {
    const url = this.getWebSocketUrl();
    this.ttsWS?.close();
    
    if ("WebSocket" in window) {
      this.ttsWS = new WebSocket(url);
    } else if ("MozWebSocket" in window) {
      this.ttsWS = new MozWebSocket(url);
    } else {
      alert("浏览器不支持WebSocket");
      return;
    }
    
    if(!option.text || !option.vcn) {
      console.log(option.text ? "未传入对话" : "未传入音源")
      return
    }
    this.ttsWS.onopen = (e) => {
      this.audioPlayer.start({
        autoPlay: true,
        sampleRate: 16000,
        resumePlayDuration: 1000
      });
      console.log(this.audioPlayer)
      var tte = "unicode"; // unicode小语种
      var str = this.encodeText(option.text, tte)
      var params = {
        common: {
          app_id: window.broadcastConfig.APPID,
        },
        business: {
          aue: "raw",
          auf: "audio/L16;rate=16000",
          vcn: option.vcn, // 发音人
          speed: window.broadcastConfig.speed || 50,
          volume: window.broadcastConfig.volume || 50,
          pitch: window.broadcastConfig.pitch || 40,
          bgs: 0,
          tte
        },
        data: {
          status: 2,
          text: str
        },
      };
      this.ttsWS.send(JSON.stringify(params));
    };
    this.ttsWS.onmessage = (e) => {
      let jsonData = JSON.parse(e.data);
      // 合成失败
      if (jsonData.code !== 0) {
        console.error(jsonData);
        return;
      }
      this.audioPlayer.postMessage({
        type: "base64",
        data: jsonData.data.audio,
        isLastData: jsonData.data.status === 2,
      });
      if (jsonData.code === 0 && jsonData.data.status === 2) {
        this.ttsWS.close();
      }
    };
    this.ttsWS.onerror = (e) => {
      console.error(e);
    };
    this.ttsWS.onclose = (e) => {
      // console.log(e);
    };
  }
}

export default broadcast